/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_MichaelInputs */

const en_onboarding_rating_michael = /** @type {(inputs: Onboarding_Rating_MichaelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great for studying and research papers. Would love to see more customization options for playback speed in the future.`)
};

const es_onboarding_rating_michael = /** @type {(inputs: Onboarding_Rating_MichaelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excelente para estudiar y artículos de investigación. Me encantaría ver más opciones de personalización para la velocidad de reproducción en el futuro.`)
};

/**
* | output |
* | --- |
* | "Great for studying and research papers. Would love to see more customization options for playback speed in the future." |
*
* @param {Onboarding_Rating_MichaelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_michael = /** @type {((inputs?: Onboarding_Rating_MichaelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_MichaelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_michael(inputs)
	return en_onboarding_rating_michael(inputs)
});